import { AdvertisingOption } from 'owa-advertising-option';
var advertisingSubCategory = {
    key: 'advertising',
    titleStringKey: 'optionSubcategory_ads',
    options: [AdvertisingOption],
};
export default advertisingSubCategory;
//# sourceMappingURL=advertisingSubCategory.js.map